<template>
  <div>
    <section style="margin-left: 20px; margin-top: 10px">
      <div class="box box-solid">
        <div class="box-body">
          <form role="form">
            <div class="form-group">
              <label class="control-label text-primary text-md"
                >Select Librarian</label
              >
              <br />
              <div class="box box-solid">
                <ul
                  class="list-group mr-4"
                  style="max-height: 300px; overflow-y: auto"
                >
                  <!-- Loop through users and display them -->
                  <li
                    class="list-group-item d-flex justify-content-between align-items-center"
                    style="cursor: pointer"
                    v-for="(user, index) in users"
                    :key="index"
                    :style="{
                      backgroundColor: user.isSelected
                        ? 'lightblue'
                        : 'transparent',
                    }"
                    @click="selectUser(index)"
                  >
                    <div>
                      <span class="font-weight-bold">{{ user.name }}</span>
                      <br />
                      <span>{{ user.email }}</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="form-group" v-if="showInstitutions">
              <label class="control-label text-primary text-md"
                >Associate Institution</label
              >
              <br />
              <div class="box box-solid">
                <h4>Institutions</h4>
                <ul
                  class="list-group"
                  style="max-height: 300px; overflow-y: auto"
                >
                  <li
                    class="list-group-item d-flex justify-content-between align-items-center"
                    style="cursor: pointer"
                    v-for="(inst, index) in institutions"
                    :key="index"
                    :style="{
                      backgroundColor: inst.isSelected
                        ? 'lightblue'
                        : 'transparent',
                    }"
                    @click.prevent="addInstitution(index)"
                  >
                    <div>
                      <span class="font-weight-bold">{{ inst.name }}</span>
                    </div>
                    <div>
                      <button class="btn btn-sm" :disabled="inst.isAdding">
                        <i
                          v-if="inst.isAdding"
                          class="fa fa-spinner fa-spin"
                        ></i>
                        <i v-else-if="inst.isAdded" class="fa fa-check"></i>
                        <i v-else class="fa fa-plus"></i>
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <hr style="border: 0.5px solid #efefef" />
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import $ from "jquery";
import "bootstrap";

export default {
  data() {
    return {
      config: {
        startDate: "",
        schedulePeriod: "",
        // institutionName: "",
        partnerType: "",
        partyType: "organization",
        selectedParty: "",
        selectedPartyName: "",
        ipRange: "",
        email: "",
      },
      filteredNames: [], // namesFiltered Add this line to define the filteredNames property,
      hasError: false,
      users: [],
      showInstitutions: false,
      institutions: [],
      currUserIdx: null,
    };
  },
  components: {},
  computed: {
    ...mapGetters("login", ["loggedInUser"]),
    ...mapGetters("admin", ["currUser", "allOrgs"]),
    ...mapGetters("users", ["librarians"]),
  },
  created() {
    if (this.loggedInUser) {
      this.config.email = this.loggedInUser.username;
    }
  },
  mounted() {
    // console.log("mounted AssociateOrgsConfig");
    this.$store.dispatch("users/getLibrarians");
  },

  watch: {
    $route: "fetchData",
    loggedInUser(newVal, oldVal) {
      // console.log("loggedInUser", newVal);
    },
    users(newVal, oldVal) {
      // console.log("users", newVal);
    },
    currUser(newVal, oldVal) {
      // console.log("currUser", newVal);
      if (newVal != null) {
        this.onCurrUserChange();
      }
    },
    allOrgs(newVal, oldVal) {
      // console.log("allOrgs", newVal);
      if (newVal != null) {
        this.onAllOrgsChange();
      }
    },
    librarians(newVal, oldVal) {
      // console.log("librarians", newVal);
      if (newVal != null) {
        this.updateLibrarians();
      }
    },
  },
  methods: {
    selectUser(index) {
      // Reset isSelected for all users
      this.users.forEach((user) => (user.isSelected = false));
      // Set isSelected to true for the selected user
      this.users[index].isSelected = true;
      this.$store.dispatch("admin/setCurrUser", this.users[index]);
      this.currUserIdx = index;
    },
    onAllOrgsChange() {},
    onCurrUserChange() {
      // console.log("onCurrUserChange", this.currUser);
      let filteredOrgs = this.allOrgs;
      let assocPartyIds = this.currUser.associatedPartyIds;
      if (assocPartyIds != null) {
        assocPartyIds = assocPartyIds.split(",");
        filteredOrgs = filteredOrgs.filter(
          (org) => !assocPartyIds.includes(org.partyId)
        );
      }
      this.institutions = filteredOrgs.map((org) => {
        return {
          id: org.partyId,
          name: org.name,
          isAdded: false,
          isSelected: false,
        };
      });

      this.showInstitutions = true;
    },
    fetchData() {
      // if (this.$route.path == "/main/usage/schedule") {
      // }
    },
    updateLibrarians() {
      // console.log("updateLibrarians ", this.librarians.length);
      this.users = this.librarians.map((user) => {
        return {
          name: user.firstName + " " + user.lastName,
          username: user.username,
          email: user.email,
          associatedPartyIds: user.associatedPartyIds,
          isSelected: false,
        };
      });
      if (this.currUserIdx != null) {
        this.selectUser(this.currUserIdx);
      }
    },
    addInstitution(index) {
      // console.log("addInstitution", index);
      const inst = this.institutions[index];
      // console.log(inst, this.currUser);
      this.$store
        .dispatch("users/add_assoc", {
          username: this.currUser.username,
          partyId: inst.id,
        })
        .then((res) => {
          // console.log(res);
          if (res.status == 200) {
            this.$store.dispatch("users/getLibrarians");
          }
        });
    },
  },
};
</script>

<style scoped>
.error-message {
  border: 1px dashed red; /* Add the desired border style and color */
  text-align: center; /* Center the text horizontally */
  padding: 10px; /* Add padding for spacing */
  margin-top: 10px; /* Add margin for spacing */
  color: red;
  margin-bottom: 10px;
}
.form-control {
  background-color: #fff !important;
}

.text-xl {
  font-size: 20px;
  font-weight: bold;
}

.text-lg {
  font-size: 16px;
  font-weight: bold;
}
.text-md {
  font-size: 14px;
  color: green;
}
</style>



// WEBPACK FOOTER //
// src/components/paywall/usage/AssociateOrgsConfig.vue